import { useState } from "react";
import { IoShareSocial } from "react-icons/io5";
import { EndButtons, EndContainer } from "./styles";
import { HelperText } from "../description/styles";
import { Firework } from "../firework/Firework";
import { ctaPhrases, getPhrase } from "../phrases/utils";
import { ShareModal } from "../sharemodal/ShareModal";
import { Container, Heading, LineSpace } from "../../global";

const EndModal = ({
  difficulty,
  handlePlayAgain,
  handleQuit,
  modeString,
  newHs,
  score,
}) => {
  const [showShare, setShowShare] = useState(false);
  const cta = getPhrase(ctaPhrases);

  return (
    <EndContainer $flexDirection={"column"} $justify={"flex-start"}>
      {showShare && (
        <ShareModal
          heading={newHs ? "Share your new high score!" : "Share your score!"}
          score={score}
          modeString={modeString}
          newHs={newHs}
          title={difficulty}
          setShowShare={setShowShare}
          showRank={false}
        />
      )}
      <Container $flex={1} $flexDirection={"column"} $justify={"space-evenly"}>
        <Heading $size={"24px"}>{difficulty}</Heading>
        <LineSpace />
        <Heading>Time's up!</Heading>
        <Heading>Score</Heading>
        <Heading $size={"48px"}>{score}</Heading>
        {newHs && (
          <>
            <Firework />
            <Heading>NEW HIGHSCORE</Heading>
          </>
        )}
      </Container>
      <Container $flex={2} $justify={"space-evenly"}>
        <EndButtons onClick={handlePlayAgain}>Play Again</EndButtons>
        <EndButtons onClick={() => setShowShare(true)}>
          <Container $gap={"5px"}>
            Share <IoShareSocial />
          </Container>
        </EndButtons>
        <EndButtons onClick={handleQuit}>Quit</EndButtons>
      </Container>
      <Container>
        <HelperText>{cta}</HelperText>
      </Container>
    </EndContainer>
  );
};

export { EndModal };
